import {
  ApiConfig
} from "./chunk-LPIRJEMY.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/grecaptcha/useRecaptcha.ts
import { useCallback, useEffect, useRef } from "react";
import { loadScriptAsync } from "@wbk/utils";
var useRecaptcha = ({ v2elementId, autoRenderV2, onLoaded, onError } = {}) => {
  const v2Token = useRef(null);
  const loadV3Script = useCallback(() => __async(void 0, null, function* () {
    var _a, _b, _c;
    try {
      if (!((_b = (_a = ApiConfig.config) == null ? void 0 : _a.grecaptcha) == null ? void 0 : _b.v3Key)) {
        throw new Error(
          "No reCAPTCHA v3 key found in config, please follow usage instruction in https://github.com/nadude/webook-frontend/blob/main/packages/api/README.md"
        );
      }
      (_c = document.getElementById("recaptcha_script")) == null ? void 0 : _c.remove();
      const url = `https://www.google.com/recaptcha/api.js?render=${ApiConfig.config.grecaptcha.v3Key}`;
      yield loadScriptAsync({ id: "recaptcha_script", url });
      if (onLoaded) {
        onLoaded();
      }
    } catch (error) {
      const err = error;
      const msg = (err == null ? void 0 : err.message) || "[USE-CAPTCHA]: Something went wrong";
      console.error(msg);
      if (onError) {
        onError(err);
      }
    }
  }), []);
  const renderV2Captcha = useCallback(() => __async(void 0, null, function* () {
    if (v2elementId && typeof window !== "undefined" && (window == null ? void 0 : window.grecaptcha)) {
      window.grecaptcha.ready(() => {
        var _a, _b;
        const el = document.getElementById(v2elementId);
        if (el && !(el == null ? void 0 : el.firstChild)) {
          try {
            if (!((_b = (_a = ApiConfig.config) == null ? void 0 : _a.grecaptcha) == null ? void 0 : _b.v2Key)) {
              throw new Error(
                "No reCAPTCHA v2 key found in config, please follow usage instruction in https://github.com/nadude/webook-frontend/blob/main/packages/api/README.md"
              );
            }
            const firstChild = document.createElement("div");
            el.appendChild(firstChild);
            window.grecaptcha.render(firstChild, {
              sitekey: ApiConfig.config.grecaptcha.v2Key,
              callback(response) {
                v2Token.current = response;
              }
            });
          } catch (error) {
            console.log(error);
          }
        }
      });
    }
  }), [v2elementId]);
  const removeV2Captcha = () => {
    if (!v2elementId)
      return;
    const el = document.getElementById(v2elementId);
    if (el == null ? void 0 : el.firstChild) {
      window.grecaptcha.reset();
      el.firstChild.remove();
      v2Token.current = "";
    }
  };
  useEffect(() => {
    loadV3Script();
  }, [loadV3Script]);
  useEffect(() => {
    if (autoRenderV2) {
      renderV2Captcha();
    }
  }, [autoRenderV2, v2elementId, renderV2Captcha]);
  const executeRecaptcha = (countryCode) => __async(void 0, null, function* () {
    return new Promise((res, rej) => {
      var _a, _b;
      try {
        if (countryCode && isSpammyCountry(countryCode) && !v2Token.current) {
          return rej({ message: "Please complete captcha" });
        }
        if (!((_b = (_a = ApiConfig.config) == null ? void 0 : _a.grecaptcha) == null ? void 0 : _b.v3Key)) {
          return rej({
            message: "No reCAPTCHA v3 key found in config, please follow usage instruction in https://github.com/nadude/webook-frontend/blob/main/packages/api/README.md"
          });
        }
        window.grecaptcha.ready(() => {
          var _a2, _b2;
          window.grecaptcha.execute(((_b2 = (_a2 = ApiConfig.config) == null ? void 0 : _a2.grecaptcha) == null ? void 0 : _b2.v3Key) || "", { action: "forced-v2" }).then(res);
        });
      } catch (error) {
        rej(error);
      }
    });
  });
  const isSpammyCountry = (countryCode) => {
    var _a, _b, _c;
    return (_c = (_b = (_a = ApiConfig.config) == null ? void 0 : _a.grecaptcha) == null ? void 0 : _b.spammyCountryCodes) == null ? void 0 : _c.includes(countryCode);
  };
  return {
    executeRecaptcha,
    renderV2Captcha,
    removeV2Captcha,
    isSpammyCountry
  };
};

export {
  useRecaptcha
};
//# sourceMappingURL=chunk-O5HX3PKI.mjs.map